<form [formGroup]="form" class="easypass-form">
    <div class="flex items-start gap-2 rounded-lg border border-blue-200 bg-blue-50 p-3 mb-2">
        <mat-icon class="text-blue-600 mt-0.5">qr_code_2</mat-icon>
        <div class="text-sm text-blue-800">
            <p class="font-medium">Enable Easypass for this space</p>
            <p>This makes Easypass available here. You can then issue individual QR passes
                (each with its own validity window and entry count) from the Parking Types list.</p>
        </div>
    </div>

    <mat-form-field appearance="fill" class="w-full">
        <mat-label>Parking Zones (optional)</mat-label>
        <mat-select formControlName="selectedZones" multiple>
            @for (zone of availableZones(); track zone.id) {
            <mat-option [value]="zone.id">{{ zone.name }}</mat-option>
            }
        </mat-select>
        <mat-hint>Restrict Easypass to specific zones — leave empty for all zones in this space</mat-hint>
    </mat-form-field>
</form>
